import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, FileText, Trash2 } from "lucide-react";
import api from "../api";
import DataTable from "../components/DataTable";
import { Button } from "../components/ui/button";
import { fmtDate } from "../utils/format";

export default function Documents() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const load = () => api.get("/documents").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const view = async (d) => {
    const r = await api.get(`/documents/${d.id}/file`);
    if (r.data?.data) window.open(r.data.data, "_blank");
  };

  return (
    <div className="space-y-5" data-testid="documents-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Documents</h1>
        <p className="mt-1 text-sm text-slate-500">Tous les justificatifs classés automatiquement par véhicule. L'ajout se fait depuis la fiche véhicule (onglet Documents).</p>
      </div>
      <DataTable testidPrefix="documents-table" rows={rows}
        searchKeys={["name", "doc_type", "vehicle_label"]}
        onRowClick={(r) => navigate(`/vehicules/${r.vehicle_id}`)}
        columns={[
          { key: "name", label: "Document", render: (r) => (
            <span className="flex items-center gap-2 font-medium text-slate-800"><FileText className="h-4 w-4 text-slate-400" /> {r.name}</span>
          ) },
          { key: "doc_type", label: "Type" },
          { key: "vehicle_label", label: "Véhicule" },
          { key: "created_at", label: "Ajouté le", render: (r) => fmtDate(r.created_at) },
          { key: "uploaded_by", label: "Par", render: (r) => <span className="text-xs text-slate-500">{r.uploaded_by}</span> },
          { key: "actions", label: "", sortable: false, render: (r) => (
            <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
              <Button size="sm" variant="ghost" onClick={() => view(r)} data-testid={`doc-view-${r.id}`}><Download className="h-4 w-4" /></Button>
              <Button size="sm" variant="ghost" className="text-red-500" data-testid={`doc-delete-${r.id}`}
                onClick={async () => { await api.delete(`/documents/${r.id}`); load(); }}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ) },
        ]}
      />
    </div>
  );
}
